import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { parseFeatureDescription, formatFieldValue } from "./FeatureDescription";
import { makeArray } from "../../../../permissionUtils";
import RelatedRecordPopup from "./RelatedRecordPopup";

const RelatedRecordDescription = ({ feature, layerId, data, setData }) => {
    return (
        data.data && (
            <>
                <Button
                    style={{
                        position: "absolute",
                        zIndex: "20",
                        cursor: "pointer",
                    }}
                    icon="arrow-left"
                    onClick={() => {
                        setData(undefined);
                    }}></Button>
                <div className="results-title">{data.config.DisplayName}</div>
                <div className="results-options">
                    <RelatedRecordPopup
                        relatedRecordInfo={data.config}
                        data={data.data}
                        feature={feature}
                        layerId={layerId}
                        setData={setData}
                    />
                </div>
                <div className="description-header">Description</div>
                <div className="feature-description">
                    {parseFeatureDescription(data.config, data.data)}
                </div>
                <div className="description-header">Details</div>
                {makeArray(data.config.Fields.Field).map((f) => {
                    if (!f.Visible) return;
                    const displayValue = formatFieldValue(f, data.data);
                    return (
                        <div key={f.Name}>
                            <div className="results-field">{f.DisplayName ?? f.Name}</div>
                            <div className="results-field-value">{displayValue}</div>
                        </div>
                    );
                })}
            </>
        )
    );
};

export default RelatedRecordDescription;
